import { FormControl, TextareaAutosize, Typography } from "@mui/material";
import { ChangeEvent, useState } from "react";
import { ICareerGoalsProps } from "../types/interfaces/ICareerGoalsProps";

//This component is responsible for rendering the goals input. 
const GoalsInput: React.FC<ICareerGoalsProps> = ({ isReadOnly, goals, onGoalsChange }) => {
    const [text, setText] = useState<string | null>(goals);
    const maxLength = 6000;
    const placeholderText = `${maxLength} Character Limit`;
    let remainingChars = maxLength;
    
    if (text !== null && text.length > 0) {
        remainingChars = maxLength - text.length;
    }

    //Function to handle a resolution response comment change.
    const goalsChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        setText(e.target.value.slice(0, maxLength));
        onGoalsChange(e.target.value);
    }
    
    return (
        <FormControl sx={{ m: 1, width: "60%", minWidth: 255 }}>
            <TextareaAutosize
                id="goals"
                minRows={3}
                placeholder={placeholderText}
                maxLength={maxLength}
                value={text || ''}
                disabled={isReadOnly}
                onChange={(e) => goalsChange(e)} />
            <Typography variant="body2" align="right">
                {remainingChars} characters left
            </Typography>
        </FormControl>
    );
}

export default GoalsInput;